import React, { useContext } from 'react';

export interface AppConfigData {
    appVersion: string;
    bugsnagApiKey: string;
    bugsnagReleaseStage: string;
    displayErrors: boolean;
    paymentsApiKey: string;
    paymentsApiModalIframeUrl: string;
    paymentsScriptUrl: string;
    recaptchaSiteKey: string;
    webpackPublicPath: string;
}

const appConfigContext = React.createContext({
    appVersion: '',
    bugsnagApiKey: '',
    bugsnagReleaseStage: '',
    displayErrors: false,
    paymentsApiKey: '',
    paymentsApiModalIframeUrl: '',
    paymentsScriptUrl: '',
    recaptchaSiteKey: '',
    webpackPublicPath: '',
});

export const AppConfigProvider = appConfigContext.Provider;
export const AppConfigConsumer = appConfigContext.Consumer;

export function useAppConfig(): AppConfigData {
    const context = useContext(appConfigContext);

    if (context === undefined) {
        throw new Error('useAppConfig must be used within a AppConfigProvider');
    }

    return context;
}
